import {createTheme} from '@mui/material/styles';


export const theme = createTheme({

    palette: {

        primary: {
            main: "#223B59",
            light: '#fff',
        },
        secondary: {
            main: "#F7F4ED",
        },
        info: {
            main: "#F7F2EC",
        },
        success: {
            main: "#9E9DA2"
        },
        action: {
            main: "#FFF"
        },
        warning: {
            main: '#fa896b'
        }

    },
    typography: {
        fontFamily: ['Poppins','Abril Fatface', 'sans-serif'].join(','),
        h1: {
            fontWeight: 600,
            color: '#223B59',
            lineHeight: 1.2,
            fontSize: 40,
            "@media (min-width:600px)": {
                fontSize: 44, // tablets
            },
            "@media (min-width:900px)": {
                fontSize: 48, // desktop
            },// puedes definir un color base
        },
        h2: {
            fontWeight: 600,
            color: '#223B59',
            lineHeight: 1.2,
            fontSize: 32, // tamaño base
            "@media (min-width:600px)": {
                fontSize: 32, // tablets
            },
            "@media (min-width:900px)": {
                fontSize: 32, // desktop
            },// puedes definir un color base
        },
        h3: {
            fontSize: 20,
            color: "#223B59",
            fontWeight: 500,
            lineHeight: 1.2,
        },
        t3: {
            fontSize: 24,
            color: "#223B59",
            fontFamily: ['Poppins', 'sans-serif'].join(','),
            fontWeight: 400,
            lineHeight: 1.2,
        },
        h4: {
            fontSize: 20,
            fontWeight: 600,
        },
        h5: {
            fontSize: 16,
            fontWeight: 600,
        },
        body1: {
            fontSize: 16,
            fontWeight: 400,
            textAlign: 'left',
            lineHeight: 1.2,
            color: '#000',
        },
        body2: {
            fontSize: 24,
            fontWeight: 400,
        },
        body3: {
            fontSize: 16,
            fontWeight: 400,
            textAlign: 'left',
            lineHeight: 1.2,
            color: '#000',
            opacity: 0.78,
        },
        allVariants: {
            color: "#303741",

        },
    },
    components: {
        MuiGrid: {
            styleOverrides: {
                root: {
                    transition: "all .2s ease-in-out"
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                fullWidth: true,
                variant: "filled",
                size: "medium"
            }
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    paddingLeft: 10,
                    paddingRight: 10,
                    borderRadius: 6
                }
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    paddingLeft: 10
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 6
                }
            }
        },
        MuiButtonBase: {
            variants: [
                {
                    props: {variant: 'efecto'},
                    style: {
                        transition: 'all .1s ease-in-out',
                        borderRadius: 10,
                        '&: hover': {
                            marginTop: -6,
                            boxShadow: "0px 0px 0px 0px rgba(0,0,0,0)",

                        }
                    },
                },


            ],

        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 16
                }
            }
        },
        MuiButton: {
            defaultProps: {
                variant: "contained",

            },
            styleOverrides: {
                root: {
                    borderRadius: 6,
                    fontWeight: 600,
                    textTransform: "none",

                },

            }
        }


    }


})